import { useContext } from 'react';

import {
  defaultFeatureToggleConfig,
  defaultIDMFeatureToggleConfig,
} from '../../default-config';
import type { RootLocationFeatureToggles } from '../../types';

import { getFeatureToggleConfigContext } from './use-feature-toggle-config-context';

export const useFeatureToggleConfig = (
  rootLocationExternalId: string
): {
  config: Record<string, boolean> | RootLocationFeatureToggles | undefined;
  isLoading: boolean;
} => {
  const { useAppConfigContext, useInFieldLocationConfig } = useContext(
    getFeatureToggleConfigContext()
  );

  const { location, isIdm } = useAppConfigContext();
  const { data: infieldLocationConfig, isPending } = useInFieldLocationConfig(
    rootLocationExternalId
  );

  if (isIdm) {
    return {
      config: (location?.featureToggles ??
        defaultIDMFeatureToggleConfig) satisfies RootLocationFeatureToggles,
      isLoading: isPending,
    };
  }

  return {
    config: (infieldLocationConfig?.featureToggles ??
      defaultFeatureToggleConfig) satisfies RootLocationFeatureToggles,
    isLoading: isPending,
  };
};
